export enum RootAppRoutes {
  Error = 'error',
  NotFound = 'not-found',
  Forbidden = 'no-access',
  Redirect = 'redirect',
  Maintenance = 'maintenance',
  Logout = 'logout',
}
